import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-container',
  templateUrl: './common-container.component.html',
  styleUrls: ['./common-container.component.css']
})
export class CommonContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
